<app-button
  class="icon-button"
  type="button"
  styleType="clear-secondary"
  [rounded]="true"
  (click)="openPanel($event, notificationsPanel)">
  <i class="pi pi-bell text-3xl" pBadge [value]="badgeValue()" [badgeDisabled]="store.unreadCount() === 0"></i>
</app-button>

<p-popover #notificationsPanel>
  <ng-template pTemplate="content">
    <div class="notifications-panel">
      <div class="notifications-panel__header">
        <span class="notifications-panel__title">Notificações</span>
        <button
          type="button"
          class="notifications-panel__action"
          [disabled]="store.unreadCount() === 0"
          (click)="markAllRead()">
          Marcar todas como lidas
        </button>
      </div>

      <div class="notifications-panel__body">
        @if (store.loading() && preview().length === 0) {
          <p class="notifications-panel__state">Carregando...</p>
        } @else if (preview().length === 0) {
          <p class="notifications-panel__state">Você não tem notificações.</p>
        } @else {
          @for (notification of preview(); track notification.id) {
            <app-notification-item
              [notification]="notification"
              (read)="handleRead($event)"
              (openAction)="handleOpenAction($event, notificationsPanel)" />
          }
        }
      </div>

      <button type="button" class="notifications-panel__footer" (click)="goToAll(notificationsPanel)">Ver todas</button>
    </div>
  </ng-template>
</p-popover>
